module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAUNJREFUWAntlr0NwjAQhc9IZAZERUmB2IEhqBiAhnFoGIAKdmAGEEiUVCgzQGHyQiwRK8Z3SQQp7pok9v18eWc7IVJTBVQBVUAVUAVUgX8qYKTFh2u7NZam/YTmt6W5cuJHGzt+PmhnDZ3uK7PgxDifnrvhXgFniSaPJx1QOBYHH/giBrExf39eDAjlyFBKlgYxSAcHX8TksT5B5FncYuTzCyd9mvnt5vhE2PLpWoAxyLbgUKc2YAgS42i9a2uVuvDhWiNAFPHVygsXa64pHHI1BkSSEuQ7a9oGHFKJdzGCfmmNFSyph+MH1pUW+3BoK/g6sUmq4NxZ+G0OLyCxWi3mAHB8OKBiQElhiW8IVryLs/W1524CtDxfl8W3G380IZDQuBgwS3TMZD9zz7kPyAt+t0IgOq4KqAKqgCqgCqgC3VTgBWhC1hdFm9lKAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/close_active@2x.png
// module id = QBqO
// module chunks = 0